import React, { useState, useRef, useEffect } from 'react';

const Select = ({ value, onChange, options = [], placeholder = "Select option", className = "", name = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (optionValue) => {
    if (onChange) {
      onChange({ target: { name, value: optionValue } });
    }
    setIsOpen(false);
  };

  const selectedOption = options.find(o => o.value === value);

  return (
    <div className={`relative ${className}`} ref={containerRef}>
       <div 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full h-full cursor-pointer"
       >
          <span className={`text-[14px] font-semibold truncate ${value ? "text-[#191C1D]" : "text-[#7D747F99]"}`}>
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          <svg className={`shrink-0 w-5 h-5 text-[#94A3B8] transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor">
             <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
          </svg>
       </div>

       {isOpen && (
         <div className="absolute top-[calc(100%+8px)] left-0 w-full min-w-[200px] bg-white rounded-[16px] shadow-[0px_10px_30px_#0000001A] border border-[#CEC3D04D] overflow-y-auto max-h-[250px] z-[100]">
            {options.length === 0 ? (
              <div className="px-4 py-3 text-[13px] text-[#7D747F] italic">No options available</div>
            ) : options.map((option) => (
              <div 
                key={option.value}
                onClick={() => handleSelect(option.value)}
                className={`px-4 py-3 text-[14px] cursor-pointer transition-colors ${value === option.value ? 'bg-[#FAF5FF] text-[#4B2364] font-bold' : 'text-[#4C444E] hover:bg-[#F3F4F5]'}`}
              >
                {option.label}
              </div>
            ))}
         </div>
       )}
    </div>
  );
};

export default Select;
